/**
 * 브랜딩 패키지 신청 캠페인 설정
 */
import RefundBadge from "../components/RefundBadge";
export default {
  id: 'brandingPackage',
  title: '촬영 패키지 신청',
  
  api: {
    list: {
      method: 'GET',
      url: '/advertisement/admin/brandingPackages'
    },
    count: {
      method: 'GET',
      url: '/advertisement/admin/brandingPackages/count'
    },
    submitted: {
      method: 'POST',
      url: '/advertisement/admin/brandingPackages/submitted'
    },
    paid: {
      method: 'POST',
      url: '/advertisement/admin/brandingPackages/paid'
    },
    complete: {
      method: 'POST',
      url: '/advertisement/admin/brandingPackages/complete'
    },
    refund: {
      method: 'POST',
      url: '/advertisement/admin/campaigns/refund',
      version: 2,
    },
    delete: {
      method: 'DELETE',
      url: '/advertisement/admin/brandingPackages'
    }
  },

  filters: {
    default: {
      status: '전체',
      submitDate: '',
      keyword: '',
      page: 1,
      limit: 50,
      submitted: '전체',
      paid: '전체',
      types: []
    },
    schema: [
      {
        name: 'types',
        label: '타입',
        type: 'checkbox-group',
        options: [
          { value: 'select', label: '브랜딩 패키지' },
          { value: 'custom', label: '촬영 상품 골라담기' },
          { value: 'blog-distribution', label: '블로그 배포용 대량 촬영' },
          { value: 'ad-video', label: '광고 영상 촬영 패키지' }
        ]
      },
      {
        name: 'keyword',
        label: '검색',
        type: 'text',
        placeholder: '신청자, 플레이스명'
      },
      {
        name: 'submitted',
        label: '접수여부',
        type: 'select',
        options: [
          { value: '전체', label: '전체' },
          { value: 'complete', label: '접수완료' },
          { value: 'notComplete', label: '미접수' }
        ]
      },
      {
        name: 'paid',
        label: '결제상태',
        type: 'select',
        options: [
          { value: '전체', label: '전체' },
          { value: 'complete', label: '결제완료' },
          { value: 'notComplete', label: '미결제' },
          { value: 'refund', label: '환불' }
        ]
      },
      {
        name: 'status',
        label: '상태',
        type: 'select',
        options: [
          { value: '전체', label: '전체' },
          { value: 'waiting', label: '대기중' },
          { value: "processing", label: "진행중" },
          { value: 'completed', label: '종료' }
        ]
      }
    ]
  },

  summary: {
    fields: [
      { key: 'totalCount', label: '총 신청' },
      { key: 'waitingCount', label: '대기중' },
      { key: 'processingCount', label: '진행중' },
      { key: 'completedCount', label: '종료' }
    ]
  },

  table: {
    keyField: 'adBrandingPackageId',
    columns: [
      {
        key: 'adCampaignMetaId',
        label: '아이디',
        center: true
      },
      {
        key: 'createdAt',
        label: '캐랭접수시간',
        center: true,
        render: (row) => {
          if (!row.createdAt) return "";
          const [date, time] = row.createdAt.split(" ");
          return (
            <>
              <div>{date}</div>
              <div>{time?.slice(0, 8)}</div>
            </>
          );
        },
      },
      {
        key: 'userName',
        label: '신청자(ID)\n상태',
        center: true,
        render: (row) => (
          <>
            <div>{row.userName}{row.userId ? ` (${row.userId})` : ''}</div>
            <div>
              <span className={`badge badge-${row.status}`}>
                {getStatusLabel(row.status)}
              </span>
            </div>
          </>
        )
      },
      {
        key: 'submitDate',
        label: '접수일',
        center: true,
        render: (row) => row.submitDate ? row.submitDate.split('T')[0] : ''
      },
      {
        key: 'title',
        label: '상품타입\n구성\n총금액',
        center: true,
        render: (row) => {
          const getConfigurationLabel = (extraProducts) => {
            if (!extraProducts || extraProducts.length === 0) {
              return '기본';
            }
            return `기본 외 ${extraProducts.length}건`;
          };
          
          return (
            <>
              <div>{row.title}</div>
              {row.type === 'ad-video' ? (
                <>
                  <div className="memo-preview" title={row.highlightAndPlatform || ''}>{row.highlightAndPlatform || ''}</div>
                  {row.referenceVideoUrl && (() => {
                    const url = toExternalUrl(row.referenceVideoUrl);
                    return url
                      ? <a href={url} target="_blank" rel="noopener noreferrer">참고 영상</a>
                      : <div>{row.referenceVideoUrl}</div>;
                  })()}
                </>
              ) : (
                <div>{row.type === 'custom' ? getConfigurationLabel(row.extraProducts) : row.packageTitle}</div>
              )}
              <div>{row.totalAmount?.toLocaleString()}원</div>
            </>
          );
        }
      },
      {
        key: 'placeName',
        label: '플레이스명\n연락처\n플레이스 URL',
        center: true,
        render: (row) => (
          <>
            <div>{row.placeName}</div>
            <div>{row.phoneNum || ''}</div>
            <div>
              {row.placeUrl && (
                <a href={row.placeUrl} target="_blank" rel="noopener noreferrer">
                  {row.placeUrl}
                </a>
              )}
            </div>
          </>
        )
      },
      {
        key: 'visitDate',
        label: '희망 시작일\n주소',
        center: true,
        render: (row) => (
          <>
            <div>{row.visitDate ? new Date(row.visitDate).toLocaleDateString() : ''}</div>
            <div>{row.roadAddress || ''}</div>
          </>
        )
      },
      {
        key: 'paymentType',
        label: '결제방법\n결제상태',
        center: true,
        render: (row) => (
          <>
            <div>
              {row.paymentType === 'card' ? '카드' :
               row.paymentType === 'v_bank' ? '가상계좌' :
               row.paymentType === 'point' ? '포인트 결제' : '계좌이체'}
            </div>
            <div>
              {row.isPaid === 2 ? (
                <RefundBadge
                  refundedAmount={row.refundedAmount ?? 0}
                  remainingAmount={row.remainingAmount ?? 0}
                  refundDate={row.refundDate}
                />
              ) : (
                <span className={`badge badge-${row.isPaid === 1 ? '결제완료' : '미결제'}`}>
                  {row.isPaid === 1 ? '결제완료' : '미결제'}
                </span>
              )}
            </div>
          </>
        )
      },
      {
        key: 'report',
        label: '리포트',
        center: true,
        render: (row) => {
          return (
            <button
              type="button"
              className="status-btn submitted"
              data-campaign-meta-id={row.adCampaignMetaId}
              data-type={row.type}
              data-place-name={row.placeName || ''}
            >
              리포트
            </button>
          );
        }
      },
      {
        key: 'notification',
        label: '알림톡',
        center: true,
        render: (row) => {
          const productName = row.title;
          
          return (
            <button
              type="button"
              className="notification-btn"
              data-campaign-meta-id={row.adCampaignMetaId}
              data-action="notification"
              data-user-id={row.userId}
              data-product-name={productName}
              data-submitted-at={row.createdAt || ''}
              data-purchase-amount={row.totalAmount ?? ''}
              onClick={(e) => e.stopPropagation()}
            >
              알림톡
            </button>
          );
        },
      },
      {
        key: 'memo',
        label: '메모',
        center: true,
        render: (row) => (
          <button
            type="button"
            className={row.memo ? 'memo-btn has-memo' : 'memo-btn'}
            data-action="memo"
            data-campaign-meta-id={row.adCampaignMetaId}
            data-memo={row.memo || ''}
            onClick={(e) => e.stopPropagation()}
          >
            {row.memo
              ? <span className="memo-preview">{row.memo}</span>
              : '메모'}
          </button>
        ),
      }
    ]
  },

  actions: [
    {
      id: 'submitted',
      label: '접수/취소',
      actionType: 'submitted',
      enabledWhen: (selectedIds) => selectedIds.length > 0,
      payloadBuilder: (selectedIds, items) => {
        const hasUnsubmitted = items.some(item => 
          selectedIds.includes(item.adBrandingPackageId) && item.isSubmitted !== 1
        );
        return {
          adBrandingPackageIds: selectedIds,
          toggleValue: hasUnsubmitted ? 1 : 0
        };
      }
    },
    {
      id: 'complete',
      label: '완료(종료)',
      actionType: 'complete',
      enabledWhen: (selectedIds) => selectedIds.length > 0,
      confirm: (selectedIds, items) => {
        const hasUncompleted = items.some(item => 
          selectedIds.includes(item.adBrandingPackageId) && item.isCompleted !== 1
        );
        return hasUncompleted ? '선택한 신청을 완료 처리하시겠습니까?' : '선택한 신청을 취소 처리하시겠습니까?';
      },
      payloadBuilder: (selectedIds, items) => {
        const hasUncompleted = items.some(item => 
          selectedIds.includes(item.adBrandingPackageId) && item.isCompleted !== 1
        );
        return {
          adBrandingPackageIds: selectedIds,
          toggleValue: hasUncompleted ? 1 : 0
        };
      }
    },
    {
      id: 'paid',
      label: '결제완료',
      actionType: 'paid',
      enabledWhen: (selectedIds, items) => {
        if (selectedIds.length === 0) return false;
        const alreadyPaid = items.some(item => 
          selectedIds.includes(item.adBrandingPackageId) && item.isPaid === 1
        );
        return !alreadyPaid;
      },
      payloadBuilder: (selectedIds) => ({
        adBrandingPackageIds: selectedIds,
        toggleValue: 1
      })
    },
    {
      id: 'refund',
      label: '환불',
      actionType: 'refund',
      requires: 'ad.campaign.refund', // 권한 없으면 버튼 숨김 (R-FE-04)
      enabledWhen: (selectedIds, items) => {
        if (selectedIds.length === 0) return false;
        return items.some(
          (item) => selectedIds.includes(item.adBrandingPackageId) && (item.isPaid === 1 || item.isPaid === 2) && (item.remainingAmount ?? item.totalAmount ?? 0) > 0
        );
      },
    },
    {
      id: 'delete',
      label: '삭제',
      actionType: 'delete',
      enabledWhen: (selectedIds) => selectedIds.length > 0,
      confirm: '선택한 신청을 삭제하시겠습니까?',
      payloadBuilder: (selectedIds) => ({
        adBrandingPackageIds: selectedIds
      })
    }
  ],

  download: {
    type: 'xlsx',
    fileName: '촬영패키지_신청목록.xlsx',
    sheetName: '촬영패키지신청목록',
    transformRow: (row) => {
      const PACKAGE_LABEL_MAP = {
        placeMain: '플레이스 대문 사진 10장',
        place: '플레이스 대문사진 5장',
        menu: '메뉴판용 사진 10장',
        sns: 'SNS 컨셉 사진 5장',
        delivery: '촬영본 배경 제거 요청 (누끼 작업)',
        motion: '대문 움직이는 사진 3장',
        menuCollection: '메뉴 모음컷 사진 3장',
        blog: '블로그 배포용 무보정 800장',
        sns15: 'SNS 숏츠 15초',
        sns30: 'SNS 숏츠 30초',
      };

      const getProductName = (type) => {
        return PACKAGE_LABEL_MAP[type] || type;
      };

      const getExtraProductsLabel = (extraProducts) => {
        if (!extraProducts || extraProducts.length === 0) {
          return '';
        }
        return extraProducts
          .map(product => `${getProductName(product.type)}(${product.price.toLocaleString()}원)`)
          .join(', ');
      };

      const getConfigurationLabel = (extraProducts) => {
        if (!extraProducts || extraProducts.length === 0) {
          return '기본';
        }
        return `기본 외 ${extraProducts.length}건`;
      };

      return {
        신청자: row.userName || '',
        접수일: row.submitDate || '',
        상품타입: row.title,
        구성: row.type === 'custom' ? getConfigurationLabel(row.extraProducts) : row.type === 'ad-video' ? '' : row.packageTitle,
        강조포인트_게시플랫폼: row.type === 'ad-video' ? (row.highlightAndPlatform || '') : '',
        참고영상링크: row.type === 'ad-video' ? (row.referenceVideoUrl || '') : '',
        추가상품: getExtraProductsLabel(row.extraProducts),
        총금액: row.totalAmount || 0,
        플레이스명: row.placeName || '',
        연락처: row.phoneNum || '',
        플레이스URL: row.placeUrl || '',
        희망시작일: row.visitDate ? new Date(row.visitDate).toLocaleDateString() : '',
        주소: row.roadAddress || ''
      };
    }
  }
};

function toExternalUrl(url) {
  const trimmed = (url || '').trim();
  if (!trimmed) return null;
  if (/^https?:\/\//i.test(trimmed)) return trimmed;
  if (/^[a-z][a-z0-9+.-]*:/i.test(trimmed)) return null; // javascript:, data: 등 차단
  return `https://${trimmed}`;
}

function getStatusLabel(status) {
  switch (status) {
    case 'waiting': return '대기중';
    case 'processing': return '진행중';
    case 'completed': return '종료';
    default: return status;
  }
}
